"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.status.pending': 'In Attesa',
    'onboarding.status.in_progress': 'In Corso',
    'onboarding.status.completed': 'Completato',
    'onboarding.status.all': 'Tutti gli Stati',
    'onboarding.status.abandoned': 'Abbandonato',
    'onboarding.status.unknown': 'Sconosciuto',
};
